import PrintMap from "./PrintMap";

export default {
    button: PrintMap,
    name: "Print",
};
